import { rootApi } from "../../api/rootApi";

export const TableauApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getTableauToken: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: "/unprotected/dashboardCron/getTableauJWT",
          headers: {
            "Content-Type": "application/json",
            slug: `${params.tenant_id}`,
            Authorization: "Bearer " + params.token,
          }
        };
      },
    }),
  }),
});

export const {
    useGetTableauTokenMutation
} = TableauApi;
